export default __webpack_public_path__ + "static/media/User Guide.de2d290c.pdf";